<script setup>
import { toRef } from 'vue';
import IntegrationLogo from 'dashboard/components-next/integrations/IntegrationLogo.vue';
import { useIntegrationHook } from 'dashboard/composables/useIntegrationHook';
import { useBranding } from 'shared/composables/useBranding';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  integrationId: {
    type: String,
    required: true,
  },
});

defineEmits(['add', 'delete']);

const { integration, hasConnectedHooks } = useIntegrationHook(
  toRef(props, 'integrationId')
);

const { replaceInstallationName } = useBranding();
</script>

<template>
  <div
    class="outline outline-n-container outline-1 bg-n-card rounded-2xl flex-grow overflow-auto p-4"
  >
    <div class="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
      <div class="flex h-12 w-12 shrink-0 items-center justify-center">
        <IntegrationLogo :integration-id="integrationId" />
      </div>
      <div class="flex min-w-0 flex-1 flex-col justify-center m-0">
        <h3 class="mb-1 text-heading-1 text-n-slate-12">
          {{ integration.name }}
        </h3>
        <p class="text-n-slate-11 text-body-main">
          {{ replaceInstallationName(integration.description) }}
        </p>
      </div>
      <div class="flex shrink-0 items-center">
        <div v-if="hasConnectedHooks">
          <div>
            <Button
              ruby
              faded
              :label="$t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT')"
              @click="$emit('delete', integration.hooks[0])"
            />
          </div>
        </div>
        <div v-else>
          <Button
            blue
            faded
            :label="$t('INTEGRATION_APPS.CONNECT.BUTTON_TEXT')"
            @click="$emit('add')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
